<template>
  <div class="row m-2" style="max-height: 70px;">
    <div class="col-sm-6 align-middle pt-2">{{name}}</div>
    <div class="col-1 align-middle pt-2 mr-2" v-on:click="descreaseCount">
      <font-awesome-icon icon="minus-circle"/>
    </div>
    <input class="col-2 form-control" :value=count v-on:change="updateCount" />
    <div class="col-1 align-middle pt-2 pl-2" v-on:click="increaseCount">
      <font-awesome-icon icon="plus-circle"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dish',
  props: {
    idx: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      count: 0
    }
  },
  methods: {
    increaseCount: function () {
      this.count++
      this.$emit('dish:choose', this.idx, this.count)
    },
    descreaseCount: function () {
      this.count--
      if (this.count < 0) {
        this.count = 0
      }
      this.$emit('dish:choose', this.idx, this.count)
    },
    updateCount: function (event) {
      this.count = parseInt(event.target.value, 10)
      this.$emit('dish:choose', this.idx, this.count)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dish.vue